export interface CboAnaliseForm {
  occupationCode: string;
  occurrenceId: string;
  step: string;
  workDescription: string;
  recommendations: string;
}

export interface CboUpdateBody {
  occupationCode: string | null;
  occurrenceId: string | null;
  step: string;
  workDescription: string | null;
  recommendations: string | null;
}

const nn = (v: string) => (v.trim() ? v : null);

export function buildUpdateBody(f: CboAnaliseForm): CboUpdateBody {
  return {
    occupationCode: nn(f.occupationCode),
    occurrenceId: nn(f.occurrenceId),
    step: f.step,
    workDescription: nn(f.workDescription),
    recommendations: nn(f.recommendations),
  };
}

export const AUTO_STATUS_LABEL: Record<string, string> = {
  SEM_DIVERGENCIA: 'Sem divergência',
  DIVERGENTE: 'Divergente',
  INVALIDO: 'Inválido',
  EXPIRADO: 'Expirado',
};

export const AUTO_STATUS_COR: Record<string, string> = {
  SEM_DIVERGENCIA: '#2F9E44',
  DIVERGENTE: '#E03131',
  INVALIDO: '#868E96',
  EXPIRADO: '#E8590C',
};
